<template>
  <v-container fluid>
    <v-snackbar v-model="snackbar" :timeout="3000" color="success" class="snackbar">
      <v-icon class="snackbar-icon" dark>mdi-check-circle</v-icon>
      <span class="snackbar-text">{{ snackbarText }}</span>
    </v-snackbar>
    <v-row>
      <!-- Barra lateral de páginas -->
      <v-col cols="3">
        <v-card class="pa-3">
          <v-list>
            <v-list-item-group v-model="selectedPage" color="primary">
              <v-list-item v-for="page in pages" :key="page.index" @click="setPageEditing(page)">
                <v-list-item-icon>
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="d-flex align-center" style="user-select: none;">
                    {{ page.name }}
                    <v-btn icon x-small class="ml-2" @click.stop="changePageName(page)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon x-small class="ml-1" @click.stop="deletePage(page.index)">
                      <v-icon small>mdi-trash-can</v-icon>
                    </v-btn>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-btn block color="primary" @click="addNewPage">+ Nueva página</v-btn>
        </v-card>
      </v-col>

      <!-- Área principal -->
      <v-col cols="9">
        <v-card>
          <v-img :src="portadaStyle.background" height="250px" class="zoomed-portada" @click="setPortada"></v-img>
          <v-card-text>
            <textarea id="markdown-editor"></textarea>
          </v-card-text>
        </v-card>
      </v-col>

      <v-row justify="space-evenly" class="mt-4">
        <v-btn color="red" @click="setView(1)">
          Atrás
        </v-btn>

        <v-btn color="primary" @click="mandarProyecto('publicado')">
          <v-icon right>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import EasyMDE from "easymde";
import "easymde/dist/easymde.min.css";
import Page from "@/models/Page";
import api from '@/api.js';

export default {
  name: "NotionComponent",
  props: {
    editing: Boolean,
  },
  data() {
    return {
      background: "",
      simplemde: null,
      snackbar: false,
      snackbarText: "Proyecto creado exitosamente!",
    };
  },
  watch: {
    seletedPage(newIndex){
      this.simplemde.value(this.$store.state.newProject.pages[newIndex].content);
    }
  },
  computed: {
    pages() {
      return this.$store.state.newProject.pages;
    },
    portadaStyle() {
      return {
        background: this.background || this.$store.state.urlPortada,
      };
    },
    selectedPage(){
      return this.$store.state.index_page_selected;
    }
  },
  methods: {
    setView(cms_view){
      this.$store.state.cms_view = cms_view;
    },
    async mandarProyecto(statusProyecto) {
      // Enviar a backend
      try {
        this.saveContent(this.selectedPage);
        this.$store.state.newProject.userOwner = localStorage.getItem("email");
        this.$store.state.newProject.kanbanColumns = ['new', 'desarrollo', 'finalizado' ];
        this.$store.state.newProject.status = statusProyecto;

        let response;
        if(!this.editing){
          response = await api.post(
            `/api/project/create`,
            this.$store.state.newProject,
            { headers: { Authorization: `Bearer ${localStorage.getItem("token")}`}});
        }else{
          response = await api.put(
            `/api/project/${this.$store.state.newProject._id}`,
            this.$store.state.newProject,
            { headers: { Authorization: `Bearer ${localStorage.getItem("token")}`}});
        }

        console.log(response);

        if (response.status === 201 || response.status === 200) {
          this.snackbar = true;
          setTimeout(() => {
            // Redirigir a /home
            this.$router.push("/home");
          }, 2000);
        }
      } catch (error) {
        console.error(error);
      }
    },
    setPortada() {
      const url = prompt("Introduce la URL de la portada:");
      if (url) {
        this.background = url;
      }
    },
    initMarkdownEditor() {
      this.simplemde = new EasyMDE({ 
        spellChecker: false, 
        initialValue: this.$store.state.newProject.pages[this.selectedPage].content
      });

      this.simplemde.codemirror.setSize("100%", "auto");
    },
    saveContent(index) {
      this.$store.commit("updatePageContent", { index: index, content: this.simplemde.value() });
    },
    setPageEditing(page) {
      if (page.index === this.$store.state.index_page_selected) return;

      // Guardar contenido antes de cambiar de página
      this.saveContent(this.selectedPage);

      // Cambiar página seleccionada en el store
      this.$store.commit("setIndexPageSelected", page.index);

      // Actualizar contenido del editor
      this.simplemde.value(this.$store.state.newProject.pages[page.index].content); // Actualizar contenido del editor
    },
    addNewPage() {
      const newPage = new Page("Nueva página", this.pages.length);
      this.$store.commit("addNewPage", newPage);
    },
    changePageName(page) {
      const newName = prompt("Introduce el nuevo nombre de la página:", page.name);
      if (newName && newName.trim() !== "") {
        this.$store.commit("updatePageName", { index: page.index, name: newName });
        page.name = newName; // Asegura que el cambio se refleje en la UI
      }
    },
    deletePage(index) {
      this.$store.commit("deletePage", index);
    }
  },
  created() {
    if (this.$store.state.newProject.pages[this.selectedPage].background == null) {
      let background = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`;
      this.$store.state.newProject.pages[this.selectedPage].background = background.replace(/rgb\((\d+), (\d+), (\d+)\)/, (_, r, g, b) => {
        return `#${parseInt(r).toString(16).padStart(2, "0")}${parseInt(g).toString(16).padStart(2, "0")}${parseInt(b).toString(16).padStart(2, "0")}`;
      });
    }
    this.background = this.$store.state.newProject.pages[this.selectedPage].background;
  },
  mounted() {
    this.initMarkdownEditor();
    this.simplemde.value(this.$store.state.newProject.pages[this.selectedPage].content);
  },
  beforeUnmount() {
    if (this.simplemde) {
      this.saveContent(this.selectedPage);
    }
  },
};
</script>

<style scoped>
#markdown-editor {
  width: 100%;
  height: 100%;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.zoomed-portada {
  object-fit: cover;
  width: 100%;
}
</style>
